import gsap from "gsap";
import { ScrollTrigger, SplitText } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, SplitText);

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".animated-text");

  if (!blocks.length) return;

  blocks.forEach((block) => {
    const split = new SplitText(block, { type: "words" });
    gsap.from(split.words, {
      opacity: 0.3,

      duration: 1,
      stagger: 0.1, // Jedes Wort kommt nacheinander
      scrollTrigger: {
        trigger: block,
        start: "top 90%",
        end: "bottom 40%",
        scrub: true,
        // markers: process.env.NODE_ENV === "development",
      },

      // Cleanup: Wenn Animation unterbrochen wird, CSS wiederherstellen
      onInterrupt: () => split.revert(),
    });
  });
});
